import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const Visionmission = () => { 
  return (
    <>
      <div className="breadcrumb">
        <h2>Vision & mission</h2>
        <ul>
          <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
          <li>|</li> <li>About</li>
          <li>|</li>
          <li>Vision & mission</li>
        </ul>
      </div>
      <div className="inner_page">
        <div className="container">
            <div className="row">
                  <div class="circleblk">
                       <div class="oval-image">
                       <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/Bishop.png" alt="st francis school, Amritsar" className="img-fluid" /></LazyLoad>
                        
                       </div>
                       <p>
                        JOSE SEBESTIAN T <span>Bishop</span></p>
                  </div>
                <div className="col-md-6">
                    <div className="vision_blk">
                        <h3 className="heading">Vision</h3>
                        <p>To enrich the journey of education by imbibing rich ethical values in students and to exhibit excellence in all spheres. We believe that a curriculum with a global dimension will help the students to face the challenges in this technocratic world.</p>                   
                    </div>
                </div>               
                <div className="col-md-6">
                    <div className="vision_blk">
                        <h3 className="heading">Mission</h3>
                        <p>To inculcate in the young minds the spirit of striving hard for perfection, and to provide a congenial atmosphere to nurture them. We endeavour hard that each child may bring out the best in himself/herself.</p>
                    </div>
                </div>
              {   /*   <div className="col-md-12">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/vision-mision1.gif" alt="st francis school, Amritsar" className="img-fluid" /></LazyLoad>
                </div> */}
            </div>
        </div>
      </div>
    </>
  )
}

export default Visionmission
